import * as style from './styles.css';
import { useSelector } from 'react-redux';
import { selectMortrageInfo } from 'shared/selectors/selectMortrageInfo';

export const Notice: React.FC = () => {
  const { disclaimer } = useSelector(selectMortrageInfo);

  return <div className={style['container']}>{disclaimer}</div>;
};
